import http from '../http-common'
import { APIBaseFunctions, APIDataSliceObj, defaultAPILimit } from '@/components/Utility/APIBase'

class MatchDateChangeDataService extends APIBaseFunctions {
  private cachedMatchDateChangeDataSliceObj: APIDataSliceObj = {
    slicemode: 0,
    start: 0,
    limit: defaultAPILimit,
    page: 0,
    pagesize: 0,
    totalcount: 0
  }

  getAll (sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    const currentDataSliceObj = MatchDateChangeDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMatchDateChangeDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      return http.get(`/kampflytnings?_sort=${sortingOrder}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
    }

    return http.get(`/kampflytnings?_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
  }

  get (id: string) {
    return http.get(`/kampflytnings/${id}`)
  }

  getCount (extraCountParameter = '') {
    return http.get('/kampflytnings/count' + (extraCountParameter.length > 0 ? `?${extraCountParameter}` : ''))
  }

  create (data: any) {
    return http.post('/kampflytnings', data)
  }

  update (id: string, data: any) {
    return http.put(`/kampflytnings/${id}`, data)
  }

  delete (id: string) {
    return http.delete(`/kampflytnings/${id}`)
  }

  deleteAll () {
    return http.delete('/kampflytnings')
  }

  findByStatus (status: boolean, sortingOrder = '', dataSliceObj: APIDataSliceObj | null = null, extraParameter = '') {
    let sortingOrderParameter = ''
    const currentDataSliceObj = MatchDateChangeDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMatchDateChangeDataSliceObj }, dataSliceObj)

    if (sortingOrder.length > 0) {
      sortingOrderParameter = `&_sort=${sortingOrder}`
    }

    return http.get(`/kampflytnings?kampflytning_status=${status}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
  }

  findBySearchTerm (status: boolean, ignoreStatus: boolean, searchTerm: string, sortingOrder = '', dataSliceBoj: APIDataSliceObj | null = null, extraParameter = '') {
    let retVal
    let sortingOrderParameter = ''
    const currentDataSliceObj = MatchDateChangeDataService.processDataSliceObj({ cachedServicesDataSliceObj: this.cachedMatchDateChangeDataSliceObj }, dataSliceBoj)
    searchTerm = searchTerm.trim()

    if (sortingOrder.length > 0) {
      sortingOrderParameter = `&_sort=${sortingOrder}`
    }

    if (Number.isNaN(searchTerm)) {
      // Handle kampprogram_kampnr search
      if (ignoreStatus) {
        retVal = http.get(`/kampflytnings?kampprogram_id.id=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      } else {
        retVal = http.get(`/kampflytnings?kampflytning_status=${status}&kampprogram_id.id=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }
    } else {
      if (ignoreStatus) {
        retVal = http.get(`kampflytnings?_where[_or][0][anmoder_hold_id.hold_holdnavn_contains]=${searchTerm}&_where[_or][1][modtager_hold_id.hold_holdnavn_contains]=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      } else {
        retVal = http.get(`/kampflytnings?kampflytning_status=${status}&_where[_or][0][anmoder_hold_id.hold_holdnavn_contains]=${searchTerm}&_where[_or][1][modtager_hold_id.hold_holdnavn_contains]=${searchTerm}${sortingOrderParameter}&_start=${currentDataSliceObj.start}&_limit=${currentDataSliceObj.limit}` + (extraParameter.length > 0 ? `&${extraParameter}` : ''))
      }
    }

    return retVal
  }
}

export default new MatchDateChangeDataService()
